var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import flatpickr from "flatpickr";
import '../../components/GateChart';
import '../../components/DonutChart';
import '../../components/ProgressChart';
import '../../components/BIBox';
import '../../components/BIBoxList';
import '../../components/BarChart';
import '../../components/GroupBarChart';
import '../../components/Table';
import '../../components/GraphChartTable';
import '../../components/RadarChart';
import '../../components/DonutsTable';
import '../../components/DonutsScaleTable';
import { colors } from "../../components/theme";
import FlatpickrControl from '../flatpickr-control';
import { fetchChartData } from './chart-api';
class ChartItem {
    constructor(chart, defaultData = {}) {
        this.apiProps = {
            questioncode: "",
            startdate: "",
            enddate: "",
            programmeid: "",
            mostrecent: false,
            surveynumber: null
        };
        this.defaultData = {};
        this.ApiCall = (defaultApiProps = {}) => __awaiter(this, void 0, void 0, function* () {
            //end point
            let endpoint = ChartItem.endPoint;
            if (this.chart.tagName.toLowerCase() === "sva-bi-box-list") {
                endpoint = ChartItem.endPointBIList;
            }
            else if (this.chart.tagName.toLowerCase() === "sva-radar-chart") {
                endpoint = ChartItem.endPointCharacteristic;
            }
            else if (this.chart.tagName.toLowerCase() === "sva-donuts-table" || this.chart.tagName.toLowerCase() === "sva-donuts-scale-table") {
                endpoint = ChartItem.endPointCustomQuestions;
            }
            // get metric
            const metric = this.chart.getAttribute("data-metric-display");
            const description = this.chart.getAttribute("data-description-display");
            //if (!this.chart.hasAttribute("data-fetch-metric")) {
            //    this.chart.setMessage("Need data-fetch-metric attribute");
            //    return;
            //}
            // show loading
            this.chart.loading = true;
            // append props
            this.apiProps = Object.assign(Object.assign({}, this.apiProps), defaultApiProps);
            // send request
            try {
                const data = yield fetchChartData(this.apiProps, endpoint, this.chart.tagName);
                const chartData = Object.assign(Object.assign({}, data), this.defaultData);
                // override metric
                if (metric && metric.length > 0) {
                    chartData.metric = metric;
                }
                // override description
                if (description && description.length > 0) {
                    chartData.description = description;
                }
                this.chart.updateData(chartData);
            }
            catch (error) {
                console.log(this.chart.wrapper, error);
                this.chart.setMessage(error);
            }
        });
        this.chart = chart;
        this.apiProps.questioncode = this.chart.getAttribute("data-fetch-question");
        this.apiProps.metrictype = this.chart.getAttribute("data-fetch-metric");
        this.apiProps.chartType = this.chart.getAttribute("data-fetch-chartType");
        this.apiProps.programmeid = this.chart.getAttribute("data-fetch-programId");
        this.apiProps.mostrecent = this.chart.getAttribute("data-most-recent") === "true";
        this.apiProps.surveynumber = this.chart.hasAttribute("data-survey-number") ? parseInt(this.chart.getAttribute("data-survey-number"), 10) : null;
        if (!this.apiProps.chartType || this.apiProps.chartType.length <= 0) {
            this.apiProps.chartType = this.chart.chartType;
        }
        this.defaultData = defaultData;
        // add filter event
        document.addEventListener("sva.charts.filter", (e) => {
            this.ApiCall(e.detail);
        });
    }
}
ChartItem.endPoint = "/api/chart";
ChartItem.endPointBIList = "/api/chart/get-analytics-overview";
ChartItem.endPointCharacteristic = "/api/chart/get-characteristics";
ChartItem.endPointCustomQuestions = "/api/chart/custom-questions";
// gate charts
window.customElements.whenDefined('sva-gate-chart').then(() => {
    [].slice.call(document.querySelectorAll("sva-gate-chart:not([ignored])")).forEach((element) => {
        // create chart item
        const myChart = new ChartItem(element);
        // make api call
        myChart.ApiCall();
    });
});
// donut charts
window.customElements.whenDefined('sva-donut-chart').then(() => {
    [].slice.call(document.querySelectorAll("sva-donut-chart:not([ignored])")).forEach((element) => {
        // create chart item
        const myChart = new ChartItem(element);
        // make api call
        myChart.ApiCall();
    });
});
// progress chart
window.customElements.whenDefined('sva-progress-chart').then(() => {
    [].slice.call(document.querySelectorAll("sva-progress-chart:not([ignored])")).forEach((element) => {
        // create chart item
        const myChart = new ChartItem(element);
        // make api call
        myChart.ApiCall();
    });
});
// boxes
window.customElements.whenDefined('sva-bi-box').then(() => {
    [].slice.call(document.querySelectorAll("sva-bi-box:not([ignored])")).forEach((element) => {
        // create chart item
        const myChart = new ChartItem(element);
        // make api call
        myChart.ApiCall();
    });
});
// box list
window.customElements.whenDefined('sva-bi-box-list').then(() => {
    [].slice.call(document.querySelectorAll("sva-bi-box-list:not([ignored])")).forEach((element) => {
        // create chart item
        const myChart = new ChartItem(element);
        // make api call
        myChart.ApiCall();
    });
});
// bar chart
window.customElements.whenDefined('sva-bar-chart').then(() => {
    [].slice.call(document.querySelectorAll("sva-bar-chart:not([ignored])")).forEach((element) => {
        // get chart type
        const type = element.getAttribute("data-chart-type");
        const defaultObj = {};
        // gender chart with secondary colors
        if (type === "3secondarycolors") {
            defaultObj["backgroundColors"] = [colors.themeSecondaryDark, colors.themeSecondary, colors.themeSecondaryLight];
        }
        // rating chart with rating colors
        else if (type === "ratingcolors") {
            defaultObj["backgroundColors"] = colors.ratingColors;
        }
        // primary colors
        else if (type === "4secondarycolors") {
            defaultObj["backgroundColors"] = [colors.primary, colors.primaryLighter, colors.primaryDark, colors.primaryLight, colors.primarySemiLight];
            ;
        }
        // create chart item
        const myChart = new ChartItem(element, defaultObj);
        // make api call
        myChart.ApiCall();
    });
});
// group bar chart
window.customElements.whenDefined('sva-group-bar-chart').then(() => {
    [].slice.call(document.querySelectorAll("sva-group-bar-chart:not([ignored])")).forEach((element) => {
        // get chart type
        const type = element.getAttribute("data-chart-type");
        const defaultObj = {};
        // gender chart with secondary colors
        if (type === "3secondarycolors_reversed") {
            defaultObj["backgroundColors"] = [colors.themeSecondaryLight, colors.themeSecondary, colors.themeSecondaryDark];
        }
        // rating chart with rating colors
        else if (type === "ratingcolors") {
            defaultObj["backgroundColors"] = colors.ratingColors;
        }
        // create chart item
        const myChart = new ChartItem(element, defaultObj);
        // make api call
        myChart.ApiCall();
    });
});
// table
window.customElements.whenDefined('sva-table').then(() => {
    [].slice.call(document.querySelectorAll("sva-table:not([ignored])")).forEach((element) => {
        // create chart item
        const myChart = new ChartItem(element);
        // make api call
        myChart.ApiCall();
    });
});
// pie + table
window.customElements.whenDefined('sva-graph-chart-table').then(() => {
    [].slice.call(document.querySelectorAll("sva-graph-chart-table:not([ignored])")).forEach((element) => {
        // create chart item
        const myChart = new ChartItem(element);
        // make api call
        myChart.ApiCall();
    });
});
// donuts + table
window.customElements.whenDefined('sva-donuts-table').then(() => {
    [].slice.call(document.querySelectorAll("sva-donuts-table:not([ignored])")).forEach((element) => {
        const myChart = new ChartItem(element);
        // make api call
        myChart.ApiCall({ customQuestionId: element.getAttribute("data-custom-question-id") });
    });
});
// sva-donuts-scale-table
window.customElements.whenDefined('sva-donuts-scale-table').then(() => {
    [].slice.call(document.querySelectorAll("sva-donuts-scale-table:not([ignored])")).forEach((element) => {
        // create chart item
        const defaultObj = {};
        defaultObj["backgroundColors"] = [...colors.ratingColors.slice(1)]; //we chop off the first one as it is "no response"];
        const myChart = new ChartItem(element, defaultObj);
        // make api call
        myChart.ApiCall({ customQuestionId: element.getAttribute("data-custom-question-id") });
    });
});
// radar
window.customElements.whenDefined('sva-radar-chart').then(() => {
    [].slice.call(document.querySelectorAll("sva-radar-chart:not([ignored])")).forEach((element) => {
        // create chart item
        const myChart = new ChartItem(element);
        // make api call
        myChart.ApiCall();
    });
});
// dashboard date filters: trigger sva.charts.filter event when dates set
const filterStartDateElement = document.querySelector("#filterStartDate");
if (filterStartDateElement) {
    const picker = new FlatpickrControl(filterStartDateElement, (date, dateString) => {
        // on change: trigger filter event if dates exist
        if (picker.currentDatePickr.selectedDates.length > 0 && picker.endDateInstance.currentDatePickr.selectedDates.length > 0) {
            document.dispatchEvent(new CustomEvent("sva.charts.filter", {
                detail: {
                    startDate: dateString,
                    endDate: flatpickr.formatDate(picker.endDateInstance.currentDatePickr.selectedDates[0], "Y-m-d"),
                }
            }));
        }
    }, (date, dateString) => {
        // on change: trigger filter event if dates exist
        if (picker.currentDatePickr.selectedDates.length > 0 && picker.endDateInstance.currentDatePickr.selectedDates.length > 0) {
            document.dispatchEvent(new CustomEvent("sva.charts.filter", {
                detail: {
                    startDate: flatpickr.formatDate(picker.currentDatePickr.selectedDates[0], "Y-m-d"),
                    endDate: dateString,
                }
            }));
        }
    });
    picker.init();
    //// reset event
    document.addEventListener("sva.charts.filter.reset", () => {
        // clear inputs
        picker.currentDatePickr.setDate(picker.currentDatePickr.config.defaultDate);
        picker.endDateInstance.currentDatePickr.setDate(picker.endDateInstance.currentDatePickr.config.defaultDate);
        // reload api
        document.dispatchEvent(new CustomEvent("sva.charts.filter", {
            detail: {
                startDate: "",
                endDate: "",
            }
        }));
    });
}
// clear filter: trigger event "sva.charts.filter.reset" to reset datepickers & re-call api
const clearTrigger = document.querySelector("#chartFilterClear");
if (clearTrigger) {
    clearTrigger.addEventListener("click", (e) => {
        e.preventDefault();
        // trigger reset event
        document.dispatchEvent(new Event("sva.charts.filter.reset"));
    });
}
export default undefined;
